export const tinValidationError = (
  value: string | null | undefined
): string | undefined =>
  value?.length === 9 && /^[0-9]{9}$/.test(value)
    ? undefined
    : 'Enter a valid TIN containing exactly 9 digits.';
